// BixGrow affiliate referral tracking.
// BixGrow's Shopify app reads the `ref` (and legacy `bg_ref`) URL parameter
// on the checkout page and attributes the sale to that affiliate.
// Since our checkout lives on Shopify, we just need to:
//   1. Capture ?ref= when a visitor lands from an affiliate link
//   2. Persist it for 30 days (matches Creator Creek cookie window)
//   3. Append it to the Shopify checkout URL when the customer checks out

const STORAGE_KEY = "cc_affiliate_ref";
const EXPIRY_KEY = "cc_affiliate_ref_exp";
const COOKIE_DAYS = 30;
// Param names BixGrow / typical affiliate links use
const REF_PARAMS = ["ref", "bg_ref", "aff", "affiliate"];

export function captureAffiliateRef(): void {
  if (typeof window === "undefined") return;
  try {
    const params = new URLSearchParams(window.location.search);
    let code: string | null = null;
    for (const p of REF_PARAMS) {
      const v = params.get(p);
      if (v) {
        code = v;
        break;
      }
    }
    if (!code) return;

    const expiresAt = Date.now() + COOKIE_DAYS * 24 * 60 * 60 * 1000;
    localStorage.setItem(STORAGE_KEY, code);
    localStorage.setItem(EXPIRY_KEY, String(expiresAt));

    // Also drop a cookie so any subdomain / SSR read can see it
    const expires = new Date(expiresAt).toUTCString();
    document.cookie = `${STORAGE_KEY}=${encodeURIComponent(code)}; expires=${expires}; path=/; SameSite=Lax`;
  } catch {
    // no-op
  }
}

export function getAffiliateRef(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const code = localStorage.getItem(STORAGE_KEY);
    const exp = Number(localStorage.getItem(EXPIRY_KEY) ?? 0);
    if (!code) return null;
    if (exp && Date.now() > exp) {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(EXPIRY_KEY);
      return null;
    }
    return code;
  } catch {
    return null;
  }
}

export function appendAffiliateRef(url: string): string {
  const code = getAffiliateRef();
  if (!code) return url;
  try {
    const u = new URL(url);
    if (!u.searchParams.has("ref")) u.searchParams.set("ref", code);
    return u.toString();
  } catch {
    return url;
  }
}
